import React from 'react';
import { Modal } from '@odin-labs/components';
import { TempBadge } from 'containers/jobsite/tabs/jobsiteTempBadges/types';
import { RegisterTempBadgeModalContent } from 'containers/jobsite/tabs/jobsiteTempBadges/modals/tempBadgeModal/components';

export function RegisterTempBadgeModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  onClosed: () => void;
  onConfirm: () => void;
  jobsiteId: string;
  jobsiteName: string;
  tempBadge: TempBadge;
}): React.ReactElement {
  const {
    isOpen,
    closeModal,
    onClosed,
    tempBadge,
    onConfirm,
    jobsiteName,
    jobsiteId,
  } = props;

  return (
    <Modal
      open={isOpen}
      setOpen={closeModal}
      afterLeave={onClosed}
      actionsPanel={null}
      title="Please enter the badge number on the printed card"
    >
      <RegisterTempBadgeModalContent
        closeModal={closeModal}
        onAction={onConfirm}
        jobsiteId={jobsiteId}
        jobsiteName={jobsiteName}
        tempBadge={tempBadge}
      />
    </Modal>
  );
}
